import { render, staticRenderFns } from "./responsible.vue?vue&type=template&id=36a09ae1&scoped=true&"
import script from "./responsible.vue?vue&type=script&lang=js&"
export * from "./responsible.vue?vue&type=script&lang=js&"
import style0 from "./responsible.vue?vue&type=style&index=0&lang=css&"
import style1 from "./responsible.vue?vue&type=style&index=1&id=36a09ae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a09ae1",
  null
  
)

export default component.exports